import { render } from "./api.vue?vue&type=template&id=cdf472be&scoped=true"
import script from "./api.vue?vue&type=script&lang=js"
export * from "./api.vue?vue&type=script&lang=js"

import "./api.vue?vue&type=style&index=0&id=cdf472be&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf472be"]])

export default __exports__